module.exports = __webpack_public_path__ + "img/counter.c56f561f.png";